import { gql } from "@apollo/client";

export const GET_STRIVE_INVENTORY_V2 = gql`
query Query($params: striveParams) {
  striveInventoryV2(params: $params) {
    data {
      TOTAL_FEE
      TOTAL_PRICE
      TOTAL_PROPERTIES
    }
  }
}
`

export const GET_STRIVE_INVENTORY_V3 = gql`
query StriveInventoryV3($params: striveParams) {
  striveInventoryV3(params: $params) {
    data {
      TOTAL_PROPERTIES
      TOTAL_PRICE
      TOTAL_FEE
    }
  }
}
`

export const GET_STRIVE_INVENTORY_BREAKDOWN_V1 = gql`
query StriveInventoryBreakdownV1($params: striveParams) {
  striveInventoryBreakdownV1(params: $params) {
    success
    message
    data {
      TOTAL_PROPERTIES
      TOTAL_PRICE
      TOTAL_FEE
    }
    error
  }
}
`